import React, { useState, useEffect, useRef } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { Alterar, Excluir, Visualizar, BtnAcaoLink } from '../../../../components/Acoes'
import { Link } from 'react-router-dom'
import { get, excluir } from '../../../../util/AcessoApi'
import { ACOES } from '../../../../util/Enums'
import { getUsuario } from '../../../../util/Configuracoes'
import { mostrarToast } from '../../../../components/Toasts'
import { mensagens } from '../../../../util/Utilitarios.js'

const ConsultaProduto = (props) => {
    const [data, setData] = useState([])
    const target = useRef(null)


    const corSaldo = item => {
        if (item.estoque_max) {
            const saldoAtual = item.quantidade || 0;
            const estoqueMin = item.estoque_min || 0
            const difEstoque = item.estoque_max - estoqueMin

            if (saldoAtual <= parseInt(estoqueMin) + (difEstoque / 4))
                return 'estoque-baixo'
            else if (saldoAtual <= parseInt(estoqueMin) + (difEstoque / 3))
                return 'estoque-medio'
            else
                return ''

        }
        return '';
    }

    const columns = React.useMemo(
        () => [
            {
                id: 'consulta-produto',
                columns: [
                    {
                        Header: 'Cód.',
                        accessor: 'id',
                        ordenamento: {
                            tipo: 'numero',
                            ativo: true,
                            modo: 'desc',
                        }
                    },
                    {
                        Header: 'Cód. Barras',
                        accessor: 'codigo_barras',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    },
                    {
                        Header: 'Produto',
                        accessor: 'descricao',
                        ordenamento: {
                            tipo: 'texto'
                        }
                    },
                    {
                        Header: 'Tipo Produto',
                        accessor: 'tipo_produto',
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            combo: 'combo-simples',
                            idColuna: 'produto.produto_tipo_id',
                            tipo: 'tipo_produto'
                        }
                    },
                    {
                        Header: 'Saldo',
                        accessor: 'quantidade',
                        html: item => <span className={corSaldo(item)}>{item.quantidade}</span>,
                        ordenamento: {
                            tipo: 'numero'
                        }
                    },
                    {
                        Header: 'Bloqueado',
                        accessor: 'bloqueado',
                        visivel: false,
                        ordenamento: {
                            tipo: 'texto'
                        },
                        filtro: {
                            combo: 'combo-simples',
                            idColuna: 'produto.bloqueado',
                            tipo: 'bloqueado'
                        }
                    },
                    {
                        Header: 'Data Registro',
                        accessor: 'data_registro',
                        ordenamento: {
                            tipo: 'data'
                        }
                    }
                ],

            },

        ],
        []
    )

    const exclusao = propsAcao => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: props.modulo,
            acao_id: ACOES.EXCLUIR
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length)
                excluir('/estoque/produto', propsAcao.id,
                    () => {
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        if (e.response && e.response.data && e.response.data.erros)
                            e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                        else
                            mostrarToast('erro', mensagens.erro)
                    })
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    const maisAcoesObj = [
        (propsAcao) => <Visualizar to={'/estoque/produto/visualizacao/' + propsAcao.id} />,
        (propsAcao) => <Alterar to={'/estoque/produto/alteracao/' + propsAcao.id} />,
        (propsAcao) => <Excluir to={'/estoque/produto/consulta/'} action={() => exclusao(propsAcao)} />,
        (propsAcao) => <BtnAcaoLink to={{ pathname: '/estoque/produtoentrada/cadastro', state: { id_produto: propsAcao.id } }} classeContent="ml-1-between" icone="icon-Add-Cart" texto="Entrada de Produto" action={_ => { }} {...props} />,
        (propsAcao) => <BtnAcaoLink to={{ pathname: '/estoque/produtosaida/cadastro', state: { id_produto: propsAcao.id } }} classeContent="ml-1-between" icone="icon-Remove-Cart" texto="Saída de Produto" action={_ => { }} {...props} />,
    ]

    return (
        <>
            <div>
                <DataGridAlternativa ref={target} data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/estoque/produto' modulo={props.modulo} titulo={'Consulta Produtos'}
                    tituloLista={'Lista Produtos'} acoesObj={maisAcoesObj}
                    urlCadastro='/estoque/produto/cadastro' icone={'icon-File-ClipboardFileText'} caminhoConsultaFiltros='/estoque/produtopaginacao' />

            </div>
        </>
    )
}

export default ConsultaProduto